/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import { useRetailerHomePage } from "@/providers/strapi/content/types/singleTypes/retailer-home-page";
import ReactMarkdown from "react-markdown";
import clsx from "clsx";


export function LearnMoreSection(_props: X.PageProps) {


  const blogCard = useRetailerHomePage('blogCard');
  const supportClientCard = useRetailerHomePage('supportClientCard')
  return (
    <section className="xl:my-20 mb-8 xl:mb-32">
      <div className="max-w-content mx-auto flex flex-col xl:flex-row items-stretch xl:gap-6">
        <div className={X.clsx("bg-surface-purple flex-1 xl:rounded-4xl py-12 xl:py-10 px-mobile-margin xl:px-10")}>
          <ReactMarkdown components={{
            p: ({ ...props }) => <h3 {...props} className="text-[26px] xl:text-[48px] [&_strong]:font-medium w-[85%] xl:w-full leading-tight mb-8" />
          }}>
            {blogCard.title}
          </ReactMarkdown>

          <div className="flex flex-row items-start xl:items-stretch gap-8 xl:gap-10">
            <div className="flex flex-col justify-between ">


              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} className="text-[15px] font-light xl:font-normal xl:text-[20px] mb-8 leading-tight xl:leading-normal" />
              }}>
                {blogCard.content}
              </ReactMarkdown>
              <div className={X.clsx(X.desktopOnly("block"))}>
                <X.Button
                  secondary desktopLg
                  href="/blog"
                  label={blogCard.cta}

                />
              </div>
            </div>

            {/* <div className={clsx([
              " md:block relative w-[50%] min-h-[100px] md:min-h-[300px] lg:min-h-[200px] shrink-0"
            ])}> */}
            <X.Image
              src={blogCard.picture.url}
              width={blogCard.picture.width}
              height={blogCard.picture.height}

              alt="Blog"
              className="w-[170px] xl:w-auto h-auto xl:h-[300px] rounded-md xl:rounded-2xl"
            />
            {/* </div> */}
          </div>

          <div className={X.clsx(X.mobileOnly(), "mt-2 xl:mt-10")}>
            <X.Button
              secondary desktopLg
              href="/blog"
              label={blogCard.cta}
            />
          </div>
        </div>

        <div className="flex-1 xl:bg-surface-blue xl:rounded-4xl py-12 xl:py-10 px-mobile-margin xl:px-10 xl:pr-4">

          <ReactMarkdown components={{
            p: ({ ...props }) => <h3 {...props} className="text-[36px] xl:text-[48px] xl:w-full leading-tight mb-8 [&_strong]:font-medium xl:mb-[38px]" />
          }}>
            {supportClientCard.title}
          </ReactMarkdown>
          <div className={X.clsx(
            X.desktopOnly("flex"),
            "flex-row gap-4 mb-[48px] mr-6",
          )}>
            <div className="h-[200px]">

              {supportClientCard.pictures[0] && <X.Image
                unoptimized
                src={supportClientCard.pictures[0].url}
                width={supportClientCard.pictures[0].width}
                height={supportClientCard.pictures[0]?.height}
                alt="Support 1" className="rounded-2xl" />}
            </div>
            <div className="h-[200px]">

              {supportClientCard.pictures[1] && <X.Image
                unoptimized
                src={supportClientCard.pictures[1].url}
                width={supportClientCard.pictures[1].width}
                height={supportClientCard.pictures[1]?.height}
                alt="Support 2" className="rounded-2xl" />}
            </div>
          </div>

          <div className={X.clsx(
            'xl:hidden',
            "flex flex-row gap-4  h-[200px] md:h-[400px] mb-6",
          )}>
            <div className=" flex-1 relative">

              {supportClientCard.pictures[0] && <X.Image
                unoptimized
                src={supportClientCard.pictures[0].url}

                fill
                alt="Support 1" className="rounded-2xl w-full object-cover" />}
            </div>
            <div className="flex-1 relative">

              {supportClientCard.pictures[1] && <X.Image
                unoptimized
                src={supportClientCard.pictures[1].url}

                fill
                alt="Support 2" className="rounded-2xl w-full object-cover" />}
            </div>
          </div>

          <X.Button
            secondary desktopLg
            href={{
              pathname: "/retail/customer-service",
            }}
            label={supportClientCard.cta}
          />
        </div>
      </div>
    </section>
  );
}
